// **********************************************************
// News Slider
// **********************************************************

const newsSlider = document.querySelectorAll('[data-slider="news-slider"]');

const newsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  watchOverflow: true,
  autoHeight: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  pagination: {
    el: '.swiper-scrollbar',
    type: 'progressbar',
  },
  breakpoints: {
    1024: {
      autoHeight: false,
    },
  },
};

const initNewsSlider = () => {
  newsSlider.forEach((el) => {
    const parent = el.closest('.news-slider');
    const paginationElement = parent.querySelector('.swiper-scrollbar');
    newsSliderOptions.pagination.el = paginationElement;

    if (windowWidth() > 767) {
      const sliderEle = new Swiper(el, newsSliderOptions);
      swiperLockClass(el, sliderEle);
    } else {
      enableScrollbarSync(parent, paginationElement);
    }
  });
};

initNewsSlider();

setupResponsiveSliders({
  sliderElements: newsSlider,
  breakpoint: 767,
  initSlider: initNewsSlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});
